<template>
    <div>
        <v-menu
            ref="menu"
            v-model="modal"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="time"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="time"
                    :label="label"
                    prepend-inner-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    :color="color ? color : inputColor"
                    :background-color="color ? `${color} lighten-5` : inputBackgroundColor"
                    :clearable="!readonly"
                    @click:clear="clear"
                    hide-details="auto"
                    :rules="rules"
                    placeholder="09:30"
                ></v-text-field>
            </template>
            <v-time-picker
                v-if="modal"
                v-model="time"
                full-width
                :readonly="readonly"
                :disabled="readonly"
                :color="color ? color : inputColor"
                @click:minute="save"
                format="24hr"
            ></v-time-picker>
        </v-menu>
        <input type="hidden"/>
    </div>
</template>

<script>
import useTools from "@/use/Tools";
import {ref, watch} from "vue";
import useSharedData from "@/use/SharedData";

export default {
    props: {
        value: String,
        label: String,
        color: String,
        min: String,
        readonly: Boolean,
        rules: Array
    },
    setup(props, { emit }) {
        const {$refs, $moment} = useTools();

        const {inputColor, inputBackgroundColor} = useSharedData();

        const modal = ref(false);
        const time = ref(null);

        watch(() => props.value, () => {
           if(props.value)
               time.value = $moment(props.value, 'HH:mm:ss').format("HH:mm");
        }, {immediate: true});

        function save() {
            // this.modal = false;
            $refs.menu.save(time.value);
            emit("input", time.value);
        }
        function clear() {
            time.value = null;
            emit("input", null);
        }

        return {
            inputColor,
            inputBackgroundColor,
            modal,
            time,
            save,
            clear,
        }
    }
};
</script>